import { pathJoin } from 'src/reducers/routing/utils'

export const createPropertiesRouteMap = (prefix: string) => ({
  'ticket-details': pathJoin(prefix)('ticket-details').chain,
  properties: pathJoin(prefix)('properties').chain,
})
